// actions/nature.ts — M1
import { defineAction, type Ok } from '../define';
import { g } from '../guard';
import type { TileXY } from '../../types/geom';
import type { ItemId, ObjectId } from '../../types/ids';
import type { ItemView } from '../../types/items';
import type { WorldObject } from '../../types/world';
declare module '../registry' {
  interface ActionMap {
    'tree.shake': { req: { tree: ObjectId }; res: { dropped: ItemView[] } };
    'fruit.plant': { req: { item: ItemId; at: TileXY }; res: { tree: WorldObject } };
    'shell.pickUp': { req: { shell: string }; res: { item: ItemView } };
    'object.remove': { req: { obj: ObjectId }; res: Ok };
  }
}
export const treeShake = defineAction('tree.shake', g.obj({ tree: g.id<ObjectId>('o') }));
export const fruitPlant = defineAction('fruit.plant', g.obj({ item: g.id<ItemId>('i'), at: g.tile }));
export const shellPickUp = defineAction('shell.pickUp', g.obj({ shell: g.token }));
export const objectRemove = defineAction('object.remove', g.obj({ obj: g.id<ObjectId>('o') }));
